// extracted by mini-css-extract-plugin
export default {"idBox":"TemplatesTable_idBox__WEfkK","arrowIcon":"TemplatesTable_arrowIcon__43K51","copyIcon":"TemplatesTable_copyIcon__CKKTz"};